import {
  AddTravellerDetailShimmer,
  DesktopLayout,
  GreatChoiceShimmer,
  Shimmer,
} from "@tm/static";
import React from "react";
import { travellerDetailData } from "./travellerDetailMockData";

const InsuranceTravellerDetailShimmer = () => {
  return (
    <React.Fragment>
      <DesktopLayout
        title={travellerDetailData?.title}
        shimmer
        leftComp={
          <React.Fragment>
            <Shimmer width="100%" height="112px" />
            <Shimmer width="100%" height="112px" />
            <GreatChoiceShimmer />
          </React.Fragment>
        }
        rightComp={
          <React.Fragment>
            <AddTravellerDetailShimmer />
          </React.Fragment>
        }
      ></DesktopLayout>
    </React.Fragment>
  );
};

export default InsuranceTravellerDetailShimmer;
